var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"max-w-5xl m-5 mb-10 w-full p-1"},[_c('InvoiceForm',{ref:"form"}),_c('div',[(
                _vm.isAdmin &&
                _vm.invoice.versions &&
                _vm.invoice.versions.length > 1 &&
                _vm.invoice.versions[_vm.invoice.versions.length - 1].id !== _vm.invoice.id
            )?_c('app-button',{staticClass:"m-2",attrs:{"size":"mini","icon":"icon-trash-can-outline","variant":"danger","label":_vm.$t('commons.removeThisVersion')},on:{"click":function($event){return _vm.removeInvoice()}}}):_vm._e()],1),_c('app-quick-actions',{attrs:{"options":_vm.quickActions},on:{"choose":function($event){return $event.run()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }